module.exports = window.L = require('leaflet/dist/leaflet-src');
